<template>
  <custom-dialog class="firmware-task-content-dialog" :appendToBody="true" width="1400px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <div class="table-box">
        <!--
              command_mode
              1-服务.提示确认，
              2-服务.状态更改，
              3-服务.弹框录入，
              4-配置.表单录入，
              5-配置.数据存档，
              6-配置.历史选择
            -->
        <!-- 指令参数 -->
        <!-- 指令参数  状态是commandTaskParamList  详情是tslList 账单共用 -->
        <template v-if="!isconfigBill">
          <el-table ref="tb1" border :size="allTableSize" v-if="contentList" :data="contentList">
            <template v-for="(item, index) in paramTableColumn">
              <el-table-column v-if="item.dicGroup" :key="index" :index="index" :prop="item.columnCode" :label="item.columnName" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ getDicValue(item.dicGroup, scope.row[item.columnCode]) }}
                  <!-- {{item.columnCode}} -->
                </template>
              </el-table-column>
              <!-- 账单日期 -->
              <!-- dataCode: "billDate" -->
              <el-table-column v-if="item.columnCode === 'billEndDate'" :key="index" :index="index" :prop="item.columnCode" :label="item.columnName" show-overflow-tooltip>
                <template slot-scope="scope">
                  <!-- {{ getDicValue(item.dicGroup,scope.row[item.columnCode]) }} -->
                  {{ formatDateTime(scope.row[item.columnCode]) }}
                </template>
              </el-table-column>
              <el-table-column v-if="`${item.widgetType}` === '5'" :key="index" :index="index" :prop="item.columnCode" :label="item.columnName" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatHhmmStr(scope.row[item.columnCode]) }}
                </template>
              </el-table-column>
              <el-table-column v-if="`${item.widgetType}` === '8'" :key="index" :index="index" :prop="item.columnCode" :label="item.columnName" show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{ formatDateTime(scope.row[item.columnCode]) }}
                    </template>
                  </el-table-column>
                   <!-- 固件地址要做权限显示  -->
                   <el-table-column v-if="item.columnCode === 'url'" :key="index" :index="index" :prop="item.columnCode" :label="item.columnName" show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{ funcView.firmware_task_download? scope.row[item.columnCode]:'-' }}
                    </template>
                  </el-table-column>
              <el-table-column
                v-if="!item.dicGroup && item.columnCode !== 'billEndDate' && `${item.widgetType}` !== '5'&& `${item.widgetType}` !== '8'&& item.columnCode !== 'url'"
                :key="index"
                :index="index"
                :prop="item.columnCode"
                :label="item.columnName"
                show-overflow-tooltip
              ></el-table-column>
            </template>
          </el-table>
        </template>
        <template v-if="isconfigBill">
          <!--存档类型 5 账单  -->
          <el-table :data="recoverHisTable" border max-height="100" style="width: 100%">
            <!-- 配置列 -->
            <template v-for="(item, index) in tableSingleColumn">
              <!-- 字典 -->
              <el-table-column
                v-if="item.selected && item.dicGroup && !item.showUnit"
                :key="index"
                :index="index"
                :prop="item.columnCode"
                :label="item.columnName"
                :width="item.width"
                :formatter="item.isFormat ? formatColumn : null"
                :sortable="item.isSort ? 'custom' : null"
                :fixed="item.isLock ? 'right' : null"
                :column-key="item.columnCode"
                :filter-multiple="true"
                :filters="item.filters"
                show-overflow-tooltip
              >
                <template slot-scope="{ row, column }">
                  {{ getDicValue(item.dicGroup, row[column.property]) }}
                </template>
              </el-table-column>
              <!-- 单位 -->
              <el-table-column
                v-if="item.selected && item.showUnit"
                :key="index"
                :index="index"
                :prop="item.columnCode"
                :label="item.columnName"
                :width="item.width"
                :formatter="item.isFormat ? formatColumn : null"
                :sortable="item.isSort ? 'custom' : null"
                :fixed="item.isLock ? 'right' : null"
              >
                <template slot-scope="{ row, column }">
                  <span>{{ row[column.property] }}</span>
                  <span style="margin-left: 5px">{{ getDicValue('iot_tsl_data_unit', item.showUnit) }}</span>
                </template>
              </el-table-column>
              <!--
                        datetime 5 时间控件
                    -->
              <el-table-column
                v-if="item.selected && (`${item.widgetType}` === '5' || `${item.widgetType}` === '8') && !item.showUnit"
                :key="index"
                :index="index"
                :prop="item.columnCode"
                :label="item.columnName"
                :width="item.width"
                :formatter="item.isFormat ? formatColumn : null"
                :sortable="item.isSort ? 'custom' : null"
                :fixed="item.isLock ? 'right' : null"
              >
                <template slot-scope="{ row, column }">
                  {{ formatDateTime(row[column.property]) }}
                </template>
              </el-table-column>
              <!-- 非字典  时间控件 -->
              <el-table-column
                v-if="item.selected && `${item.widgetType}` !== '5' && `${item.widgetType}` !== '8' && !item.dicGroup && !item.showUnit"
                :key="index"
                :index="index"
                :prop="item.columnCode"
                :label="item.columnName"
                :width="item.width"
                :formatter="item.isFormat ? formatColumn : null"
                :sortable="item.isSort ? 'custom' : null"
                :fixed="item.isLock ? 'right' : null"
                :column-key="item.columnCode"
                :filter-multiple="true"
                :filters="item.filters"
                show-overflow-tooltip
              ></el-table-column>
            </template>
            <!-- 占位列 -->
            <el-table-column v-if="!tableSingleColumn.length"></el-table-column>
          </el-table>
          <!-- <div class="table-bd"> -->
          <el-table ref="tb1" style="margin-top: 20px" :data="hisBillList" :loading="isHisLoading" resizable border>
            <!-- 配置列 -->
            <template v-for="(item, index) in hisTableColumns">
              <!-- 字典 -->
              <el-table-column
                v-if="item.selected && item.dicGroup && !item.showUnit"
                :key="index"
                :index="index"
                :prop="item.columnCode"
                :label="item.columnName"
                :width="item.width"
                :formatter="item.isFormat ? formatColumn : null"
                :sortable="item.isSort ? 'custom' : null"
                :fixed="item.isLock ? 'right' : null"
                :column-key="item.columnCode"
                :filter-multiple="true"
                :filters="item.filters"
                show-overflow-tooltip
              >
                <template slot-scope="{ row, column }">
                  {{ getDicValue(item.dicGroup, row[column.property]) }}
                </template>
              </el-table-column>
              <!-- 单位 -->
              <el-table-column
                v-if="item.selected && item.showUnit"
                :key="index"
                :index="index"
                :prop="item.columnCode"
                :label="item.columnName"
                :width="item.width"
                :formatter="item.isFormat ? formatColumn : null"
                :sortable="item.isSort ? 'custom' : null"
                :fixed="item.isLock ? 'right' : null"
              >
                <template slot-scope="{ row, column }">
                  <span>{{ row[column.property] }}</span>
                  <span style="margin-left: 5px">{{ getDicValue('iot_tsl_data_unit', item.showUnit) }}</span>
                </template>
              </el-table-column>
              <!--
                        datetime 5 时间控件
                    -->
              <el-table-column
                v-if="item.selected && (`${item.widgetType}` === '5' || `${item.widgetType}` === '8') && !item.showUnit"
                :key="index"
                :index="index"
                :prop="item.columnCode"
                :label="item.columnName"
                :width="item.width"
                :formatter="item.isFormat ? formatColumn : null"
                :sortable="item.isSort ? 'custom' : null"
                :fixed="item.isLock ? 'right' : null"
              >
                <template slot-scope="{ row, column }">
                  {{ formatDateTime(row[column.property]) }}
                </template>
              </el-table-column>

              <!-- 非字典  时间控件 -->
              <el-table-column
                v-if="item.selected && `${item.widgetType}` !== '5' && `${item.widgetType}` !== '8' && !item.dicGroup && !item.showUnit"
                :key="index"
                :index="index"
                :prop="item.columnCode"
                :label="item.columnName"
                :width="item.width"
                :formatter="item.isFormat ? formatColumn : null"
                :sortable="item.isSort ? 'custom' : null"
                :fixed="item.isLock ? 'right' : null"
                :column-key="item.columnCode"
                :filter-multiple="true"
                :filters="item.filters"
                show-overflow-tooltip
              ></el-table-column>
            </template>
            <!-- 占位列 -->
            <el-table-column v-if="!tableColumn.length"></el-table-column>
          </el-table>
          <!-- </div> -->
        </template>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {
    // model: {
    //   title: '',
    //   data: row
    // }
  },
  data() {
    return {
      paramList: [],
      paramDataList: [],
      paramTableColumn: [],

      tslContent: [],
      contentList: [],
      isconfigBill: false,
      // 字典name值
      iot_cmd_task_service_type: {},
      progressFlagTimeOut: null,
      // 账单期数
      recoverHisTable: [],
      tableSingleList: [],
      tableSingleColumn: [],
      hisBillList: [],
      hisTableColumns: [],
      commandMode: null,
    };
  },
  computed: {
    billList() {
      if (this.periodNum || this.recoverPwdObj.dataName) {
        const obj = {};
        if (this.periodNum) {
          obj.periodNum = this.periodNum;
        }
        if (this.recoverPwdObj.dataValue) {
          obj.dataValue = this.recoverPwdObj.dataValue;
        }
        return [obj];
      }
      return [];
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    getTslCodeList() {
      this.$getJSON(apis.commandTaskTslDataList, {
        taskId: this.model.data.taskId,
        productCode: this.model.data.productCode,
        tcpVersion: this.model.data.tcpVersion,
        topicCode: this.model.data.topicCode,
      }).then((res) => {
        // configBill 是多列
        // list
        this.tslContent = res.data.find(i => i.dataType === 'List');
        this.isconfigBill = res.data.some(i => i.tslCode === 'billContent');
        // 为 list 的
        if (this.isconfigBill) {
          this.isHisLoading = false;
          // 没有子级的
          const firstLevelId = res.data.filter(i => `${i.parentId}` === '0');
          // 内容体
          const contentId = res.data.find(i => `${i.parentId}` !== '0').parentId;
          // 过滤内容体
          const tableSingle = firstLevelId.filter(i => i.tslDataId !== contentId);
          const content = firstLevelId.find(i => i.tslDataId === contentId);
          // 一级的单个表格列
          this.tableSingleColumn = tableSingle.map((i) => {
            const item = {};
            item.columnName = i.dataName;
            item.columnCode = i.dataCode;
            item.columnId = i.tslDataId;
            item.widgetType = i.widgetType;
            item.dicGroup = i.dicGroup;
            item.showUnit = i.showUnit;
            item.selected = true;
            return item;
          });
          // 一级的数据  取dataValue值
          const recoverTable = [];
          tableSingle.forEach((i) => {
            const item = {};
            item[i.dataCode] = i.dataValue || '-';
            recoverTable.push(item);
            // return item;
          });
          let recoverTableobj = {};
          recoverTable.forEach((item) => {
            recoverTableobj = { ...recoverTableobj, ...item };
          });
          this.recoverHisTable = [recoverTableobj];
          this.hisBillList = content.dataValue || [];
          // this.hisBillList = [{
          //   billNum: 1,
          //   billEndDate: '2012-10-02',
          //   deferredDuration: '10',
          //   unlockPwd: '321322',
          //   paid: '0'
          // }];

          // 不为0 有下级的都是下面的表格列
          const paramColumn = res.data.filter(i => `${i.parentId}` !== '0');
          this.hisTableColumns = paramColumn.map((i) => {
            const item = {};
            item.columnName = i.dataName;
            item.columnCode = i.dataCode;
            item.columnId = i.tslDataId;
            item.widgetType = i.widgetType;
            item.dicGroup = i.dicGroup;
            item.showUnit = i.showUnit;
            item.selected = true;
            // 账单状态要用字典
            // if (i.dataCode === 'paid') {
            //   this.paidDicGroup = i.dicGroup;
            // }
            return item;
          });
        } else {
          // 非list 普通tsl
          // const editArr = res.data;
          res.data.forEach((i) => {
            // 设置表格列
            let column = {};
            column = i;
            column.columnCode = i.dataCode;
            column.columnName = i.dataName;
            column.widgetType = i.widgetType;
            if (column.columnCode === 'size') {
              column.columnName = `${column.columnName} (${i.showUnit})`;
            }
            this.paramTableColumn.push(column);
          });
          const obj = {};
          res.data.forEach((i) => {
            obj[i.columnCode] = i.dataValue;
          });
          this.contentList.push(obj);

          // this.billContent = res.data;
        }
      });
    },
    closeDialog() {
      this.visible = false;
    },
  },
  created() {},
  mounted() {
    this.getTslCodeList();
    this.getFuncView();
  },
};
</script>

<style lang="scss">
.firmware-task-content-dialog {
  .table-box {
    // padding: 0 24px 24px;
    box-sizing: border-box;
    flex: 1;
    overflow-y: auto;
    .table-title {
      height: 60px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      line-height: 60px;
    }
    .title {
      height: 40px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(57, 70, 104, 1);
      line-height: 40px;
    }
    .table-bd {
      height: 100%;
    }
  }
}
</style>
